import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const MarketingAgentItems = memo(function MarketingAgentItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const marketingRpcClient = useRequiredContext(RedoMarketingRpcClientContext);

  const featureFlagLoad = useLoad(
    () =>
      marketingRpcClient.getUserFeatureFlag({
        key: FeatureFlagKey.AI_MARKETING_AGENT,
      }),
    [marketingRpcClient],
  );

  if (featureFlagLoad.pending || featureFlagLoad.error) {
    return null;
  }

  const isEnabled = featureFlagLoad.value?.enabled;

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.marketingAgentHref }}
      FilledIcon={AiStarIcon}
      friendlyName="Marketing Agent"
      hidden={!isEnabled}
      id="marketing-agent"
      UnfilledIcon={AiStarIcon}
    />
  );
});
